

import React, { useEffect, useContext } from "react";
import { SessionContext } from "./state/SessionContext";

import { TagFill, TagsFill } from "react-bootstrap-icons";
import { Dropdown } from "react-bootstrap";
import { SESSION_ACTIONS } from "./state/SessionReducer";
import { sendCommand } from "../components/Bridge";
import { useTranslation } from "react-i18next";
import { IconButton, Divider } from "@material-ui/core";
import { DeleteForever, OpenInNew, Star, Settings } from "@material-ui/icons";


function SessionListToolbar({match}){

    const { sessionState : state, dispatchSessionState : dispatchState } = useContext(SessionContext);

    const { t } = useTranslation();

    const categorize = (categoryId, level) => {
        //console.log(categoryId, level);
        let ids = [];
        state.selectedRows.forEach((row) => {
          ids.push(row.id);
        });
        dispatchState({
          type: SESSION_ACTIONS.CATEGORIZE,
          ids: ids,
          categoryId : categoryId,
          level : level
        });
      }
  
      const toggleBookmark = () => {
        let allBookmarked = true;
        let ids = [];
        state.selectedRows.forEach((row) => {
          ids.push(row.id);
          if (!row.bookmark) {
            allBookmarked = false;
          }
        });
        dispatchState({
          type: SESSION_ACTIONS.TOGGLE_BOOKMARKS,
          ids: ids,
          bookmark : !allBookmarked
        });
      };

    useEffect(()=>{
        console.log("SessionListToolbar effect");

        return (()=>{
            console.log("SessionListToolbar effect done");
        });
    });

    return (<>
      <Dropdown className="categories" >
        <Dropdown.Toggle variant="success" id="categories-dropdown" >
          <TagsFill size="16"></TagsFill>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item disabled={state.selectedRows.length === 0} onClick={() => categorize(-1, -1, state)}><TagFill className="color" style={{ color: "transparent" }}></TagFill>{t("app.session.categorization.none")}</Dropdown.Item>
          <Dropdown.Divider></Dropdown.Divider>
          {state.categories.levelColors.map((level, index) =>
            index < 10 ?
              <Dropdown.Item key={"category-" + index} disabled={state.selectedRows.length === 0} onClick={() => categorize(index, level, state)}><TagFill className="color" style={{ color: "rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")" }}></TagFill>{state.categories.names[index]}</Dropdown.Item> : <></>

          )}
          <Dropdown.Divider></Dropdown.Divider>
          <Dropdown.Item onClick={() => window.toggleOptions("session-category-management")}><Settings></Settings>{t("app.session.categorization.title")} ...</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <IconButton className="bookmark" disabled={state.selectedRows.length === 0} onClick={() => toggleBookmark(state.selectedRows)}><Star></Star></IconButton>
      <IconButton disabled={state.selectedRows.length !== 1} onClick={() => {
        sendCommand("session/replay", {sessionId:state.selectedRows[0].id, heroId : match.params.hero});
      }}><OpenInNew></OpenInNew></IconButton>
      <Divider orientation="vertical" flexItem />
      <IconButton disabled={state.selectedRows.length === 0} onClick={() => {
        dispatchState({
          type: SESSION_ACTIONS.CONFIRM_DELETION,
          payload: true
        });
      }}><DeleteForever></DeleteForever></IconButton>
    
    </>)
}
export default SessionListToolbar;